import { EventEmitter2 } from 'eventemitter2';

export const wsEventsEmitter = new EventEmitter2({
	wildcard: false,
	delimiter: '.',
	maxListeners: 50,
});
